import $ from 'jquery';
import { repository } from 'repositories/articleRepository';
import ArticleModel from 'models/ArticleModel';
import SocialMediaWidget from '@ui/article/social-media-share-view';
import StickyComponent from '@components/sticky-component';
import { generateAdSlot } from 'utils/adManager';

export const elements = {
    socialWidget: '.c-article-main-social',
    socialContainer: '.c-article-main-social__container',
    loadMore: '.c-comments__loadMore',
};

const getMinutesVariant = (minutes) => {
    if (minutes === 1) {
        return 'minutę';
    } else if (minutes >= 2 && minutes <= 4) {
        return 'minuty';
    } else {
        return 'minut';
    }
}

const applyReadingTime = () => {
    const readingTime = document.querySelector('.article-reading-time');
    if (readingTime) {
        const wordsPerMinute = 200;
        const paragraphs = document.querySelectorAll('.article-content-regular p');
        const wordsInParagraphs = Array.from(paragraphs).reduce((acc, p) => acc + p.textContent.split(' ').length, 0);
        const minutes = Math.ceil(wordsInParagraphs / wordsPerMinute);
        readingTime.innerHTML = `<p>Ten artykuł przeczytasz w <b>${minutes} ${getMinutesVariant(minutes)}.</b></p>`;
    }
}

const removeStylesFromTablesInArticleWhenDarkModeEnabled = () => {
    if (!document.body.classList.contains('dark-mode')) {
        return;
    }
    const tables = document.querySelectorAll('.article-content-regular table');
    tables.forEach(table => {
        const rows = table.querySelectorAll('tr');
        rows.forEach(row => {
            row.querySelectorAll('td').forEach(td => {
                td.removeAttribute('style');
            });
            row.removeAttribute('style');
        })
        table.removeAttribute('style');
    });
}

export default {
    init() {
        repository.load().then(data => {
            const articleModel = ArticleModel.fromJSON(data);
            let isHorizontal = false;
            removeStylesFromTablesInArticleWhenDarkModeEnabled();
            $(elements.socialWidget).each((index, element) => {
                const socialMediaWidget = new SocialMediaWidget(articleModel);
                socialMediaWidget.bulkArticleShareTrigger({
                    isHorizontal,
                });
                socialMediaWidget.render({ showPrintButton: true });
                isHorizontal = !isHorizontal;

                $(element)
                    .find(elements.socialContainer)
                    .append(socialMediaWidget.getRootEl());
            });
        });

        $(document).ready(() => {
            /**
             * Add event listener to react on adBlock
             */
            window.addEventListener(
                'onAdBlockerDetectionFinish',
                e => {
                    if (e.detail) {
                        $('.article-content-regular').remove();
                        $('.aci-adblock-information').addClass('aci-visible');
                        $('.aci-adblock-to-apply').addClass('aci-applied');
                        $('.aci-to-hide').addClass('aci-hide-it');
                    } else {
                        applyReadingTime();
                    }
                },
                false
            );

            document.addEventListener(
                'CommentsInitialised',
                () => {
                    const hash = window.location.hash;
                    if (hash && hash.slice(1) === 'comments') {
                        /*
                         * Make smooth scroll to comments, when section is fully loaded
                         */
                        const top = $('#c-comments').offset().top - 65;
                        $('html, body')
                            .animate({ scrollTop: top }, 1000)
                            .promise();
                    } else {
                        /*
                         * Make smooth scroll to article comment,
                         * trying to load more comment while searching
                         */
                        if (hash && hash.slice(1, 8) === 'comment') {
                            const commentId = hash.replace(hash.slice(0, 8), '');
                            if (isNaN(commentId)) {
                                return;
                            }
                            const $loadMore = $(elements.loadMore);
                            let $comment = $(hash);

                            if (!$comment.length && !$loadMore.length) {
                                return;
                            }

                            const interval = setInterval(function() {
                                $comment = $(hash);

                                if ($comment.length) {
                                    const top = $comment.offset().top - 65;
        
                                    $('html, body')
                                        .animate({ scrollTop: top }, 1000)
                                        .promise();

                                    clearInterval(interval);
                                    return;
                                }

                                if ($loadMore.hasClass('fn-hidden')) {
                                    clearInterval(interval);
                                    return;
                                }

                                $loadMore.find('button').trigger('click');
                            }, 0);
                        }
                    }
                },
                false
            );

            const $stickyWrappers = $('.sticky-component');
            $stickyWrappers.each(function() {
                const $stickyWrapper = $(this);
                const $stickyFixed = $stickyWrapper.find('.sticky-component-fixed');

                const stickyComponent = new StickyComponent($stickyWrapper, $stickyFixed);
                stickyComponent.init();
            });
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/article/index.js